module.exports = __webpack_public_path__ + "static/img/banner.c787442.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.jpeg
// module id = m1Fl
// module chunks = 1